if (!customElements.get('collapsible-content-prod-manuly')) {
    customElements.define('collapsible-content-prod-manuly',
        class CollapsibleContentProduct extends HTMLElement {

            constructor() {
                super();
                let element = this.querySelectorAll('.accordion');
                let element1 = this.querySelector('#variantTextDesc');
                if(element1 != null)
                    this.variantTextDesc = JSON.parse(element1.innerHTML).data
            }


            connectedCallback() {
                this.onVariantChangeUnsubscriber = subscribe(
                    PUB_SUB_EVENTS.variantChange,
                    this.handleOptionValueChange.bind(this)
                );
            }

            handleOptionValueChange(data) {
                this.querySelectorAll('.accordion').forEach(item => {

                    var htmlElement = item.querySelector('div');
                    if(htmlElement !== null) {
                        let innerHTML = this.replaceDynamics(htmlElement.getAttribute('data-content'), data);
                        if (innerHTML != null) {
                            htmlElement.innerHTML = innerHTML;
                        }
                    }
                });
                let querySelector = data.data.html.querySelector('#varianttext');
                let element = this.querySelector('.variant__collapsible__content');
                if (querySelector != null) {
                    if (element == null) {
                        let replace = JSON.parse(querySelector.innerHTML.replaceAll('\n', '')).data.specs;
                        this.createCollapisbleElenent(replace);
                    }
                    else{
                        let replace = JSON.parse(querySelector.innerHTML.replaceAll('\n', '')).data.specs;
                        element.querySelector("details").querySelector("div").innerHTML = replace;
                    }
                } else if (element != null) {
                    element.remove();
                }
            }

            replaceDynamics(text, data) {
                if (text == null) return null;
                text = text.replace('%DESCRIPTION%', this.dataset.description)
                text = text.replace('%DYNSIZING%', data.data.variant.option1);

                text = text.replace('%DYNSIZING%', data.data.variant.option1);
                text = text.replace('%MATERIAL%', data.data.variant.option2);

                text = text.replace('$Mobile$', '');
                text = text.replace('$EndMobile$', '');
                text = text.replace('$ENDING$', '');

                return text.replace('%Metafield-Color%', data.data.variant.option1);


            }

            createCollapisbleElenent(txt) {
                let i = 0;
                let unde = false;
                while (this.querySelector("#Details-" + i + "-" + this.dataset.secid) != null && !unde) {
                    i += 2;
                    if (i >= 100) unde = true;
                }
                if (unde) return;

                let outerDiv = document.createElement("div");
                outerDiv.classList.add("accordion");
                outerDiv.classList.add("variant__collapsible__content");

                let details = document.createElement("details");
                details.setAttribute("id", "Details-" + i + "-" + this.dataset.secid);

                let summary = document.createElement("summary");
                summary.setAttribute("id", "Summary-" + i + "-" + this.dataset.secid);



                const SVG_NS = 'http://www.w3.org/2000/svg'
                let iconspan = document.createElement("span");
                iconspan.classList.add("svg-wrapper");
                let icon = document.createElementNS(SVG_NS, "svg");
                icon.setAttribute("aria-hidden", "true");
                icon.setAttribute("viewBox", "0 0 20 20");
                icon.classList.add("icon");
                icon.classList.add("icon-accordion");
                icon.classList.add("icon-clipboard");

                let pathicon = document.createElementNS(SVG_NS, "path");
                let pathicon1 = document.createElementNS(SVG_NS, "path");
                pathicon.setAttributeNS(null, "d", "M6.311 9.136a.25.25 0 0 1 .25-.25h7.185a.25.25 0 0 1 0 .5H6.561a.25.25 0 0 1-.25-.25M6.311 14.054a.25.25 0 0 1 .25-.25h6.878a.25.25 0 0 1 0 .5H6.561a.25.25 0 0 1-.25-.25M6.926 11.595a.25.25 0 0 1 .25-.25h5.648a.25.25 0 1 1 0 .5H7.176a.25.25 0 0 1-.25-.25M5.196 1.778a1.5 1.5 0 0 1 1.5-1.5h6.608a1.5 1.5 0 0 1 1.5 1.5v1.69a1.5 1.5 0 0 1-1.5 1.5H6.696a1.5 1.5 0 0 1-1.5-1.5zm1.5-.5a.5.5 0 0 0-.5.5v1.69a.5.5 0 0 0 .5.5h6.608a.5.5 0 0 0 .5-.5v-1.69a.5.5 0 0 0-.5-.5z");
                pathicon1.setAttributeNS(null, "d", "M3.737 2.508v16.215h12.526V2.508h-1.765v-1h1.765a1 1 0 0 1 1 1v16.215a1 1 0 0 1-1 1H3.737a1 1 0 0 1-1-1V2.508a1 1 0 0 1 1-1H5.76v1z");

                icon.appendChild(pathicon);
                icon.appendChild(pathicon1);
                iconspan.appendChild(icon);

                let h3 = document.createElement("h3");
                h3.classList.add("accordion__title");
                h3.classList.add("inline-richtext");
                h3.classList.add("h4");
                h3.innerText = this.variantTextDesc;

                let svg = document.createElementNS(SVG_NS,"svg");
                svg.classList.add("icon");
                svg.classList.add("icon-caret");
                svg.setAttribute("viewBox", "0 0 10 6");

                let path = document.createElementNS(SVG_NS,"path");
                path.setAttribute("fill", "currentColor");
                path.setAttribute("fill-rule", "evenodd");
                path.setAttributeNS(null, "d", "M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708");
                path.setAttribute("clip-rule", "evenodd");

                svg.appendChild(path);

                summary.appendChild(iconspan);
                summary.appendChild(h3);
                summary.appendChild(svg);

                let innerDiv = document.createElement("div");
                innerDiv.classList.add("accordion__content");
                innerDiv.classList.add("rte");
                innerDiv.classList.add("collapsible-content-manuly");
                innerDiv.setAttribute("id", "CollapsibleAccordion-" + (i + 1) + "-" + this.dataset.secid);
                innerDiv.setAttribute("role", "region");
                innerDiv.innerHTML = txt;


                details.appendChild(summary);
                details.appendChild(innerDiv);

                outerDiv.appendChild(details);

                this.querySelector("#collap-content-prod").prepend(outerDiv);

            }
        });
}